export class BulkRestoreItem {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "templateId",
            "baseName": "templateId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "selector",
            "baseName": "selector",
            "type": "SnapshotSelector",
            "format": ""
        },
        {
            "name": "preferredSnapshotId",
            "baseName": "preferredSnapshotId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BulkRestoreItem.attributeTypeMap;
    }
    constructor() {
    }
}
